'use client';

import { FC, HTMLAttributes, useMemo, useState, MouseEvent } from 'react';
import { Dialog, DialogContent } from '@tuic/web-compositions/shared/Dialog';
import PrismAPI from '@modules/prism-client/types/prism-types';
import { SurveyContent } from './SurveyContent';
import { toValidLocale } from '@tuic/i18n';
import { useDialogTelemetry } from '@modules/prism-client/lib/telemetry';
type Props = HTMLAttributes<HTMLAnchorElement> & {
  data: PrismAPI.SurveyLink;
};
export const SurveyLink: FC<Props> = ({
  data,
  children,
  ...props
}) => {
  const [open, setOpen] = useState(false);
  useDialogTelemetry(data.telemetry, open);

  // Parse survey parameters from URL
  const surveyParams = useMemo(() => {
    const url = new URL(data.url, window.location.origin);
    const params = new URLSearchParams(url.search);
    return {
      surveyId: parseInt(params.get('surveyId') || '0', 10),
      apiToken: params.get('apiToken') || '',
      userAge: params.has('userAge') ? parseInt(params.get('userAge')!, 10) : undefined,
      locale: toValidLocale(params.get('locale'))
    };
  }, [data.url]);
  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setOpen(true);
  };
  return <>
      <a {...props} href={data.url} onClick={handleClick} data-no-page-transition="true">
        {children}
      </a>
      <Dialog open={open} onOpenChange={setOpen} data-sentry-element="Dialog" data-sentry-source-file="SurveyLink.tsx">
        <DialogContent fullscreen title={data.title} disableSpacing data-sentry-element="DialogContent" data-sentry-source-file="SurveyLink.tsx">
          <SurveyContent {...surveyParams} data-sentry-element="SurveyContent" data-sentry-source-file="SurveyLink.tsx" />
        </DialogContent>
      </Dialog>
    </>;
};